{
  "schemaVersion": 1,
  "id": "sheesham-board-70",
  "version": "1.0",
  "kind": "board",
  "species": "Sheesham",
  "material": "Solid sheesham",
  "nominalDescription": "Solid sheesham 70 mm, face-laminated from two 35 mm boards, planed all round, oiled",
  "edgeDescription": "Solid sheesham, planed, 1 mm arris",
  "thicknessTicks": 700,
  "nominalThicknessTicks": 700,
  "maxWidthTicks": 2000,
  "maxLengthTicks": 24000,
  "grainAxis": "length",
  "finishSpec": "Hard-wax oil, two coats",
  "density": 770,
  "back": {
    "description": "Birch plywood 6 mm, B/BB, stained to match",
    "thicknessTicks": 60,
    "nominalThicknessTicks": 60,
    "sheet": {
      "lengthTicks": 24400,
      "widthTicks": 12200
    },
    "grainAxis": "length",
    "allowRotation": false
  },
  "notes": "Self-authored chunky slab stock (pilot-v1-r3 p14: slabs reading about 70 mm): two 35 mm sheesham boards face-laminated and planed to 70 mm, in the same widths as the sheesham-board-45 profile; wider parts are edge-glued from strips by the same rule (plan §5). Back and finish as sheesham-board-45."
}
